var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"current-balance"},[(_vm.showError)?_c('div',{staticClass:"notification is-danger"},[_vm._v(" An error was encountered trying to retrieve your balance. Please check your network connection and try again. ")]):_c('h2',[_vm._v("$"+_vm._s(_vm.balance.toFixed(2)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }